import { Input, Output, EventEmitter } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { CupsService } from '../../../../../services/cups.service';

@Component({
  selector: 'app-manage-customers-create',
  templateUrl: './manage-customers-create.component.html',
  styleUrls: ['./manage-customers-create.component.css']
})
export class ManageCustomersCreateComponent implements OnInit {
  @Input() formData: any;
  @Input() formType: any;
  @Output() reLoadGrid = new EventEmitter();
  apiResp: any;
  apiRequest = {
    "created_by": sessionStorage.getItem('userid'),
    "is_active": true
  };
  selectedBU: any;
  constructor(private _service: CupsService, private spinner: NgxSpinnerService, private toastr: ToastrService) { }

  ngOnInit() {
  }

  cancel() {
    this.reLoadGrid.emit(false);
  }

  submitSoldTo() {
    if (this.checkValidations()) {
      this.spinner.show();
      if (this.formType === 'New') {
        this.apiRequest[''] = 0;
      } else {
        this.apiRequest['customer_id'] = this.formData.soldToSalesOrgConfigID ;
      }
      this.apiRequest['soldTo'] = this.formData.soldTo;
      this.apiRequest['soldToName'] = this.formData.soldToName;
      this.apiRequest['salesOrg'] = this.formData.salesOrg;
      this._service.submitSoldTo(this.apiRequest).subscribe(response => {
        this.spinner.hide();
        if (!response['isError']) {
          response['responseMessage'] = response['message'];
          this._service.displayToastr(response);
          this.apiResp = response;
          if (response['responseMessage'] != 'Duplicate data.') {
            this.formData = { 'soldToSalesOrgConfigID': 0, 'soldTo': '', 'soldToName': '', 'SalesOrg': '' };
          }
          this.reLoadGrid.emit(true);
        } else {
          this._service.displayToastr(response);
        }
      })

    }
  }

  checkValidations() {
    if (this.formData.soldTo == null || this.formData.soldTo == undefined || this.formData.soldTo == '') {
      this.toastr.error("Sold to required field");
      return false;
    }
    if (this.formData.soldToName == null || this.formData.soldToName == undefined || this.formData.soldToName == '') {
      this.toastr.error("Sold to name required field");
      return false;
    }
    if (this.formData.salesOrg == null || this.formData.salesOrg == undefined || this.formData.salesOrg == '') {
      this.toastr.error("Sales Org required field");
      return false;
    }
    return true;
  }

}

